<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{ this.$route.name }}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="openPage('/userManagement/approval-roles')" class="btn-grey"><i
                class="fas fa-arrow-circle-left mr-5"></i>Back</a>
          </div>
        </div>
      </div>
      <!-- Form Input -->
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <div class="row justify-content-center mt-30">
          <div class="col-sm-10">
            <form @submit.prevent="validateRegister">
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Branch</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select name="branch_id" @change="onBranchOrDepartmentChange" v-model="addData.branch_id"
                    v-validate="'required'">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{ item.name }}</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('branch_id') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Department</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select name="department" @change="onBranchOrDepartmentChange" v-model="addData.department"
                    v-validate="'required'">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataDepartment" :key="item" :value="item">{{ item }}</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('department') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Edit Role</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select name="edit_user_role_id" v-model="addData.edit_user_role_id" v-validate="'required'">
                    <option :value="null">Please select</option>
                    <option v-for="item in allUserRole" :key="item.user_role_id" :value="item.user_role_id">
                      {{ item.role_name }}</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('edit_user_role_id') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Delete Role</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select name="delete_user_role_id" v-model="addData.delete_user_role_id"
                    v-validate="'required'">
                    <option :value="null">Please select</option>
                    <option v-for="item in allUserRole" :key="item.user_role_id" :value="item.user_role_id">
                      {{ item.role_name }}</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('delete_user_role_id') }}</span>
                </b-col>
              </b-row>
              <!-- <b-row class="mb-20">
                <b-col sm="2">
                  <label>Access Menu</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select name="access_menu_id" v-model="addData.access_menu_id" v-validate="'required'">
                    <option :value="null">Please select</option>
                    <option v-for="item in itemAccessMenu" :key="item.id" :value="item.id">{{ item.name }}</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('access_menu_id') }}</span>
                </b-col>
              </b-row> -->

              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Access Menus</label>
                </b-col>
                <b-col sm="10">
                  <template>
                    <div class="menu-container">
                      <!-- CHECK ALL -->
                      <div class="checkbox-item parent">
                        <label>
                          <input type="checkbox" :checked="isAllChecked" @change="toggleAll($event)" />
                          <strong>Check All</strong>
                        </label>
                      </div>

                      <!-- PARENT MENU -->
                      <div v-for="parent in parentMenus" :key="parent.id" class="parent-box">
                        <div class="checkbox-item parent">
                          <label>
                            <input type="checkbox" :checked="isParentChecked(parent.id)"
                              @change="toggleParent(parent.id, $event)" />
                            <strong>{{ parent.name }}</strong>
                          </label>
                        </div>

                        <!-- CHILD MENU -->
                        <div class="children">
                          <div v-for="child in getChildren(parent.id)" :key="child.id" class="checkbox-item child">
                            <label>
                              <input type="checkbox" :value="child.id" v-model="selectedMenus" />
                              {{ child.name }}
                            </label>
                          </div>
                        </div>
                      </div>

                      <!-- ORPHAN MENU (function != Parent, parent_code tidak cocok ke Parent manapun) -->
                      <div v-if="orphanMenus.length > 0" class="parent-box">
                        <div class="checkbox-item parent">
                          <strong>Other Menu</strong>
                        </div>
                        <div class="children">
                          <div v-for="orphan in orphanMenus" :key="orphan.id" class="checkbox-item child">
                            <label>
                              <input type="checkbox" :value="orphan.id" v-model="selectedMenus" />
                              {{ orphan.name }}
                            </label>
                          </div>
                        </div>
                      </div>

                      <!-- <hr />

                      <h3>Selected Menu IDs</h3>
                      <pre>{{ selectedMenus }}</pre> -->
                    </div>
                  </template>
                </b-col>
              </b-row>

              <div class="text-right">
                <button type="submit" class="btn-primary">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading -->
    <div v-if="loadingActive == true" class="loading-container">
      <div class="wrap-screen w-100 h-100">
        <img :src="`/svg-loaders/oval.svg`" width="60" alt="" />
        <div class="title-loading color-white">Loading...</div>
      </div>
    </div>

  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'

export default {
  name: 'addSales',
  data: function () {
    return {
      loadingActive: false,
      itemAccessMenu: [],
      selectedMenus: [],
      allUserRole: [],
      dataBranch: [],
      dataDepartment: [],
      addData: {
        access_menu_id: 0,
        branch_id: null,
        department: null,
        edit_user_role_id: null,
        delete_user_role_id: null,
      },
      confirm_password: '',
      imageData: '',
      imgUpload: null,
      salesRole: '',
      branchSalesId: '',
      file: null,
      options: [
        { value: null, text: 'Please select' },
        { value: 'active', text: 'Active' },
        { value: 'inactive', text: 'Inactive' }
      ]
    }
  },
  computed: {
    parentMenus() {
      return this.itemAccessMenu.filter(
        (item) => item.function === "Parent"
      );
    },

    /**
     * MENU TANPA PARENT (function != Parent, parent_code tidak cocok ke Parent manapun)
     */
    orphanMenus() {
      const parentIds = this.parentMenus.map((p) => String(p.id));
      return this.itemAccessMenu.filter(
        (item) =>
          item.function !== "Parent" && !parentIds.includes(String(item.parent_code))
      );
    },

    /**
     * CHECK ALL STATUS
     */
    isAllChecked() {
      const childIds = this.itemAccessMenu
        .filter((item) => item.function !== "Parent")
        .map((item) => item.id);

      return childIds.every((id) =>
        this.selectedMenus.includes(id)
      );
    },
  },
  methods: {
    /**
     * GET CHILD MENU
     */
    getChildren(parentId) {
      return this.itemAccessMenu.filter(
        (item) =>
          String(item.parent_code) === String(parentId)
      );
    },
    /**
     * CHECK PARENT STATUS
     */
    isParentChecked(parentId) {
      const children = this.getChildren(parentId);

      if (!children.length) return false;

      return children.every((child) =>
        this.selectedMenus.includes(child.id)
      );
    },
    /**
     * TOGGLE PARENT
     */
    toggleParent(parentId, event) {
      const checked = event.target.checked;

      const children = this.getChildren(parentId);

      if (checked) {
        children.forEach((child) => {
          if (!this.selectedMenus.includes(child.id)) {
            this.selectedMenus.push(child.id);
          }
        });
      } else {
        this.selectedMenus = this.selectedMenus.filter(
          (id) =>
            !children.some((child) => child.id === id)
        );
      }
    },
    /**
     * TOGGLE ALL
     */
    toggleAll(event) {
      const checked = event.target.checked;

      const childIds = this.itemAccessMenu
        .filter((item) => item.function !== "Parent")
        .map((item) => item.id);

      if (checked) {
        this.selectedMenus = [...childIds];
      } else {
        this.selectedMenus = [];
      }
    },
    validateRegister() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loadingActive = true
          axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token

          Object.assign(this.addData, {
            list_menus: this.selectedMenus
          })
          axios.post('crm/v1/approval_roles/', this.addData).then(response => {
            this.loadingActive = false
            // console.log('test', response)
            this.$router.push('/userManagement/approval-roles')
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }).catch(error => {
            this.loadingActive = false
            // console.log('error log', error)
            this.$toast.success('cant saved data!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    openPage(event) {
      this.$router.push(event)
    },
    // Edit/Delete Role options depend on BOTH branch and department - only
    // fetch once both are picked, and reset any role already chosen for the
    // previous branch/department pair since it may not exist in the new one.
    onBranchOrDepartmentChange() {
      this.addData.edit_user_role_id = null
      this.addData.delete_user_role_id = null

      if (!this.addData.branch_id || !this.addData.department) {
        this.allUserRole = []
        return
      }

      this.loadingActive = true
      axios.get(`crm/v1/approval_roles/branch/roles?branch_id=${this.addData.branch_id}&department=${this.addData.department}`).then(response => {
        this.loadingActive = false
        this.allUserRole = response.data.data
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })
    },
    previewImage: function (event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData = e.target.result;
        }
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    fetchData() {
      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
        // console.log('test', response)
      }).catch(error => {
        console.log('error', error)
      })

      axios.get('crm/v1/approval_roles/departments').then(response => {
        this.dataDepartment = response.data.data
      }).catch(error => {
        console.log('error', error)
      })

      axios.get('vendor/v1/user_role').then(response => {
        var data = response.data.data.rows
        // this.allUserRole = data.filter(item => item.id != 1 && item.id != 3 && item.id != 4 && item.id != 5 && item.id != 6 && item.id != 7 && item.id != 8 && item.id != 9 && item.id != 12)
        // console.log('test', response.data.data.rows)
        // this.allUserRole = data
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('vendor/v1/access_menu').then(response => {
        this.itemAccessMenu = response.data.data.rows
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created() {
    this.fetchData()
  }
}
</script>

<style scoped>
  .menu-container {
    max-width: 700px;
    margin: auto;
    padding: 20px;
    font-family: Arial, sans-serif;
  }

  .parent-box {
    border: 1px solid #ddd;
    border-radius: 10px;
    padding: 12px;
    margin-bottom: 16px;
  }

  .checkbox-item {
    margin-bottom: 8px;
  }

  .parent {
    font-size: 16px;
  }

  .children {
    padding-left: 15px;
    margin-top: 10px;
    border-left: 2px solid #e5e5e5;
    margin-left: 8px;
  }

  .child {
    margin-bottom: 6px;
  }

  input[type="checkbox"] {
    margin-right: 8px;
  }

  pre {
    background: #f5f5f5;
    padding: 12px;
    border-radius: 8px;
    overflow: auto;
  }
</style>
